import LoadMoreComponent from '../../components/LoadMoreComponent';

import query, { getAllQuery } from './query';
import { COLUMNS, FIELD_FOR_DOWNLOADS } from './keys';
import CheckData from '../../components/CatchError';
import DataTable from '../../components/Datatable';
import { scrollForTable } from '../../components/Datatable/utils';
import AuthorsModal from '../../components/Modals/AuthorsModal/AuthorsModal';
import { downloadAllCsv } from '../../helpers/downloadAll';
import { withTranslation } from 'react-i18next';

class Summary extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({
            offset: 0,
            author: props.author,
        });

        this.onOpen = this.onOpen.bind(this);
        this.exportAll = this.exportAll.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.offsetStep = 50;
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.page?.toLowerCase().includes(search.toLowerCase()));
    }

    onCloseModal() {
        this.setState({
            isOpen: false,
            image: null,
        });
    }

    onOpen(item) {
        this.setState({
            isOpen: true,
            selectedItem: item,
        });
    }

    async exportAll() {
        const { t } = this.props;
        try {
            this.setState({
                exportAllLoading: true,
            });
            const allQuery = getAllQuery({ author: this.props.author });
            const response = await allQuery.update();
            downloadAllCsv(response, 'Pages', [
                ...COLUMNS(this.props.default_image, t),
                ...FIELD_FOR_DOWNLOADS(t),
            ]);
            this.setState({
                exportAllLoading: false,
            });
        } catch (err) {
            this.setState({
                exportAllLoading: false,
            });
            console.log(err);
        }
    }

    render() {
        const { t } = this.props;
        const attr = {
            query,
            offsetStep: this.offsetStep,
            author: this.props.author,
        };
        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const sortFns = {
            page: (array) => array.sort((a, b) => a.page.localeCompare(b.page)),
            lifespan: (array) => array.sort((a, b) => a.lifespan - b.lifespan),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
            uniques: (array) => array.sort((a, b) => a.uniques - b.uniques),
        };
        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.state.data}
                    loading={this.state.loading}
                    loadMore={this.state.loadMore}
                >
                    <DataTable
                        nodes={this.state.allData}
                        sortFns={sortFns}
                        COLUMNS={COLUMNS(this.props.default_image, t, this.onOpen)}
                        fileName={t('discover.author.top_pages.header')}
                        header={t('discover.author.top_pages.header')}
                        forceRun={this.forceRun}
                        searchFunction={this.searchFunction}
                        customColumnsForExport={[
                            ...COLUMNS(this.props.default_image, t),
                            ...FIELD_FOR_DOWNLOADS(t),
                        ]}
                        showLoadMoreBtn={showLoadMoreBtn}
                        loadMoreLoading={this.state.loadMore}
                        loadMore={() => this.loadMore(attr)}
                        exportAll={this.exportAll}
                        exportAllLoading={this.state.exportAllLoading}
                        additionalStyles={{
                            Table: `
                                --data-table-library_grid-template-columns :  minmax(200px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                ${scrollForTable}
                            `,
                            BaseCell: `  font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                        }}
                    />
                </CheckData>
                {this.state.selectedItem && (
                    <AuthorsModal
                        isOpen={this.state.isOpen}
                        onClose={this.onCloseModal}
                        item={this.state.selectedItem}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Summary);
